import React from 'react'
import PropTypes from 'prop-types'
import flow from 'lodash/flow'
import { withRouter } from 'react-router'
import { NavDropdown, MenuItem } from 'react-bootstrap'
import { LinkContainer } from 'react-router-bootstrap'

class NavTools extends React.Component {
  render() {
    const { apps, user } = this.props
    if (!apps || !apps.tools || user.auth > 1) return null

    return (
      <NavDropdown title='Tools' id='nav-tools'>
        {
          apps.tools.map( (item, i) => (
            <LinkContainer key={i} to={item.alias} activeClassName='active'>
              <MenuItem>
                <span className='px-nav-icon'><item.icon size={12}/></span>
                {item.name}
              </MenuItem>
            </LinkContainer>
          ))
        }
      </NavDropdown>
    )
  }
}

NavTools.propTypes = {
  strings: PropTypes.object,
  apps: PropTypes.object,
  user: PropTypes.object,
}

const decorators = flow([
  withRouter
])

export default decorators(NavTools)



// WEBPACK FOOTER //
// ./src/components/nav/NavTools.js